export class AffiliateNetworkAdvertisers {
    AffiliateNewtorkId: number;
    AffiliateNewtorkName: string;
    Advertisers: Advertiser[];
}

export class Advertiser {
    AdvertiserId: string;
    AdvertiserName: string;
    FriendlyName: string;
    URL: string;
    OldCashback: string;
    Cashback: string;
    Image: Int16Array[];
    CustomerCashback: string;
    Added: Date | null;
    EndDate: Date | null;
    Featured: boolean | null;
    DealOfWeek: boolean | null;
}